module.exports = __webpack_public_path__ + "static/media/dashboard2.ad3b9a8e.png";